import useStore from "stores/index";
import { User, userDisplayText } from "../../utils/userUtils";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { getClassroomStore } from "stores/classroomStore";
import Tooltip from "rc-tooltip";
import React, { FC } from "react";
import { default as IconPinClass } from "assets/IconPinClass.svg";
import { default as IconSignOut } from "assets/IconSignOut.svg";
import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface Props {
	user: User;
	isStudentClaimReleasable: boolean;
	onStudentClaimReleaseClick: () => void;
	actionsJsx?: React.ReactNode;
}

export const StudentTileHeader: FC<Props> = (props) => {
	const { t } = useTranslation();
	const displayName = userDisplayText(props.user);

	const selectedClassroomStore = useSelectedClassroomStore();
	const pinned = selectedClassroomStore.findStudent(props.user.username)?.pinned ?? false;

	const toggleStudentPin = () => {
		const teacherStableIdV1 = getClassroomStore(useStore.getState()).getTeacherStableIdV1() as string;
		void selectedClassroomStore.toggleStudentPin(teacherStableIdV1, props.user.username);
	};

	return (
		<div className="StudentTileHeader">
			{props.isStudentClaimReleasable && (
				<Tooltip
					placement="top"
					trigger={["hover"]}
					destroyTooltipOnHide={true}
					overlayClassName="Tooltip"
					overlay={<span>{t("studentTile.releaseClaim")}</span>}
				>
					<div
						className="Pin_button release_claim_button"
						onClick={props.onStudentClaimReleaseClick}
						data-testid={`student-release-claim-button-${props.user.username}`}
					>
						<div className="relese_claim_button_icon">
							<IconSignOut />
						</div>
					</div>
				</Tooltip>
			)}
			<Tooltip
				placement="top"
				trigger={["hover"]}
				destroyTooltipOnHide={true}
				overlayClassName="Tooltip"
				overlay={<span>{pinned ? t("studentTile.unpinStudent") : t("studentTile.pinStudent")}</span>}
			>
				<div
					className="Pin_button"
					onClick={toggleStudentPin}
					data-testid={`student-pin-button-${props.user.username}`}
					data-test-active={pinned}
				>
					<div className={pinned ? "Pin_active" : "Pin"}>
						<IconPinClass />
					</div>
				</div>
			</Tooltip>
			<div className="StudentTileHeader_title">{displayName}</div>
			{props.actionsJsx && (
				<Flex alignItems={"center"} gap={"6px"} width={"100%"}>
					{props.actionsJsx}
				</Flex>
			)}
		</div>
	);
};
